import React, { useContext, useEffect } from "react";
import { AuthContext } from "./AuthContext";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import {Link} from "react-router-dom"

export default function Logout() {
    const navigate = useNavigate();
        const { logOut ,token} = useContext(AuthContext);  


   
    

    const handleLogout=()=>{
        if(token){
            const decodedToken=jwtDecode(token);
            let role=decodedToken?.sub?.role;
            if (!window.confirm("Are you sure you want to logout")){
                navigate(-1);
                return
            }
            else{
                logOut();
                navigate("/loginUser")
            }
        }
    }

    useEffect(() => {
        handleLogout()
    }, []);

    return <p className=" flex items-center font-bold text-3xl mt-4 mx-4">You have Logged out kindly log in <Link to="/loginUser" className=" hover:text-blue-500">Login</Link></p>
}
